/**
 * avatarInitials(user) — derive 1-2 character initials from a Clerk user object.
 *
 * Preference order:
 *   1. firstName + lastName (first letter of each, uppercase) → "Eric Mogollon" → "EM"
 *   2. fullName ("Eric Mogollon" → "EM"; "Eric" → "E")
 *   3. firstName alone → first letter of firstName
 *   4. primaryEmailAddress.emailAddress → first letter, uppercase
 *   5. Fallback: '?'
 *
 * Defensive against null/undefined and empty strings.
 */
export function avatarInitials(user) {
  if (!user) return '?'

  const first = (user.firstName || '').trim()
  const last = (user.lastName || '').trim()

  if (first && last) {
    return (first[0] + last[0]).toUpperCase()
  }

  const full = (user.fullName || '').trim()
  if (full) {
    const parts = full.split(/\s+/).filter(Boolean)
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }
    if (parts.length === 1) {
      return parts[0][0].toUpperCase()
    }
  }

  if (first) {
    return first[0].toUpperCase()
  }

  const email = user.primaryEmailAddress?.emailAddress || ''
  if (email && email[0]) {
    return email[0].toUpperCase()
  }

  return '?'
}
